import { room } from "../../../model/room";

export interface IState {
    rooms: Array<room>;
    room?: room;
    // edit?: boolean;
    loading?: boolean;
}

export const DefaultState = (): IState => ({
    rooms: [],
})